export default __webpack_public_path__ + "static/media/content-support.7be229d9.png";